import React, { Component } from 'react';

import { RelatedEntityGrid as EntityGrid } from 'hay-core-react';
import { ModelTextArea } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelCalendar } from 'hay-core-react';
import PesquisaExecucaoLog                from '../../../models/PesquisaExecucaoLog';
import Pesquisa                           from '../../../models/Pesquisa';
import PesquisaExecucaoLogStatusEnum      from '../../../enums/PesquisaExecucaoLogStatusEnum';
import PesquisaExecucaoLogTipoExecucaoEnum from '../../../enums/PesquisaExecucaoLogTipoExecucaoEnum';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    id: { exibir: 'main.id', tipo: 'numeric', largura: '5rem', fixar: true },
    pesquisa: {
        exibir:       'main.pesquisaexecucaolog.pesquisa',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'nome',
        entidade:     'pesquisa.entidade',
        template:     'pesquisa.template',
    },
    status: {
        exibir:   'main.pesquisaexecucaolog.status',
        visivel:  true,
        tipo:     'enum',
        entidade: 'pesquisaexecucaolog.status',
        largura: "7rem",
        fixar: true
    },
    tipoexecucao: {
        exibir:   'main.pesquisaexecucaolog.tipoexecucao',
        visivel:  true,
        tipo:     'enum',
        entidade: 'pesquisaexecucaolog.tipoexecucao',
        largura: "7rem",
        fixar: true
    },
    datahorainicio: { exibir: 'main.pesquisaexecucaolog.datahorainicio', visivel: true, tipo: 'date', time: true, largura: '12rem', fixar: true },
    datahorafim:    { exibir: 'main.pesquisaexecucaolog.datahorafim',    visivel: true, tipo: 'date', time: true, largura: '12rem', fixar: true },
    log:            { exibir: 'main.pesquisaexecucaolog.log' },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const renderers = {
    pesquisa:                          { entidade: Pesquisa, template: (rowData) => rowData.pesquisa?.nome || rowData.pesquisa?.id || '' },
    'pesquisaexecucaolog.status':       PesquisaExecucaoLogStatusEnum,
    'pesquisaexecucaolog.tipoexecucao': PesquisaExecucaoLogTipoExecucaoEnum,
};

// ─── Formulário de campos (render prop) ────────────────────────────────────────

// Todos os campos sao preenchidos automaticamente pelo processo agendado que gerou o registro
// (ver Pesquisa.executar) - nunca editaveis diretamente pelo admin, essa tela e so um historico de
// execucoes.
class PesquisaExecucaoLogFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        return (
            <div className="grid">
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={{ ...model.pesquisa, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={{ ...model.status, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={{ ...model.tipoexecucao, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelCalendar model={{ ...model.datahorainicio, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelCalendar model={{ ...model.datahorafim, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 mt-3">
                    <ModelTextArea model={{ ...model.log, disabled: true }} contexto={contexto} rows={12} />
                </div>
            </div>
        );
    }
}

// ─── Template (componente exportado) ──────────────────────────────────────────

class PesquisaExecucaoLogTemplate extends Component {
    render() {
        return (
            <EntityGrid
                entidade={PesquisaExecucaoLog}
                model={model}
                identidade="main.pesquisaexecucaolog"
                permissoes={this.props.permissoes}
                icone="pi-list"
                storageKey="dt-pesquisaexecucaologs"
                relacionados={[]}
                renderers={renderers}
                configuracao={this.props.configuracao}
                ordenacaoPadrao={{ sortField: 'datahorainicio', sortOrder: -1 }}
                formulario={(m, ctx) => <PesquisaExecucaoLogFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default PesquisaExecucaoLogTemplate;
